import { Injectable, Inject, EventEmitter, Output } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ConfigService } from "./config.service";
import { AppState } from "../../app-state";
// any import removed to break circular dependency:
// DataService → any → BaseComponent → DataService.
// pagesLayout is now typed as `any` for backward compatibility.
import { ActivatedRoute, Router } from "@angular/router";
import { ResponseModel } from "../models/ResponseModel";

@Injectable()
export class DataService {
  serverUrl = "";
  apiUrl: string;

  get loginUrl(): string {
    return this.cs.loginEndPoint;
  }

  companyName: string;

  static CompanyName2: string;

  static pagesLayout: any;

  static timerRefresh: EventEmitter<any> = new EventEmitter<any>();

  @Output() static ResponseEmitter: EventEmitter<any> = new EventEmitter<any>();

  static LoggedInUserId: any;
  static LoggedInUserDisplayName: any;
  static IsLoggedInUserAdmin: any;
  static IsLoggedInUserGuest: any;
  static LoggedInUserEmailAddress: any;
  static CurrentCompany: any;

  constructor(
    private http: HttpClient,
    private cs: ConfigService,
    @Inject("BASE_URL") baseUrl: string
  ) {
    this.serverUrl = baseUrl;
    this.apiUrl = this.cs.apiEndPoint;
  }

  getCompanyName() {
    if (this.companyName == null) {
      this.companyName = "";
    }

    return this.getCompanyNameFromUrl(window.location.href);
  }

  async getCompanyInfo() {
    var result: any = await this.getSync("Auth/GetCompanyInfoV2", null);
    return result;
  }

  getCompanyNameFromUrl(url: string): string | null {
    const urlParts = url.split("/");

    // JM: check the number of occurances for 'print' and checks for 'c' route the url
    const printMatch = url.match(/print/g); // for print layout
    const cMatch = url.includes("/c/"); // for client layout

    // JM: condition if url is print.
    // CompanyPath is located on position 4 in 'print' and 'c' path.
    const positionToExtract =
      (printMatch && printMatch.length > 1) || cMatch ? 4 : 3; // Replace with the desired position (0-based index)

    if (urlParts.length > positionToExtract) {
      return urlParts[positionToExtract];
    }

    // Return null if the segment does not exist
    return null;
  }

  debugLog(obj: any, description: string) {
    return;

    //console.group(description);
    //console.log(obj);
    //console.groupEnd();
  }

  registerPageLayout(layout: any) {
    DataService.pagesLayout = layout;
  }

  static sendRefreshEmitter() {
    DataService.timerRefresh.emit();
  }

  async ping() {
    try {
      await this.http.post(this.apiUrl + "/api/Auth/Ping", null).toPromise();
      return "API is up.";
    } catch (e) {
      return "Your internet connection may be down.";
    }
  }

  //Post File
  postform(action: string, parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "company-name": this.getCompanyName(),
      }),
    };
    return this.http.post(this.apiUrl + action, parameters, options);
  }

  get(action: string, params: HttpParams) {
    console.log("this.apiUrl", this.apiUrl);
    var companyName = this.getCompanyName();

    if (companyName != null && companyName != "") {
      DataService.CompanyName2 = companyName;
    }

    if (companyName == null || companyName == "") {
      console.debug("Cannot get company name");
      return null;
    }

    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
      params: params,
    };
    return this.http.get(this.apiUrl + action, options);
  }

  delete(action: string, params: HttpParams) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
      params: params,
    };

    return this.http.delete(this.apiUrl + action, options);
  }

  post(action: string, parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
    };

    var url = this.apiUrl + action;
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  put(action: string, parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
    };

    var url = this.apiUrl + action;
    return this.http.put(url, JSON.stringify(parameters), options);
  }

  login(parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
      withCredentials: true // Enable cookies for refresh token
    };

    var url = this.loginUrl + "/api/auth/login";
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  loginWithTurnstile(parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
      withCredentials: true
    };

    var url = this.loginUrl + "/api/auth/login-verified";
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  getCompanyInfoByUser(email: string) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
    };


    var url = this.loginUrl + "/api/auth/GetCompanyInfoByUser";
    return this.http.post(url, JSON.stringify({ Email: email }), options);
  }

  // New: Fetch Microsoft IDs (TenantId/AppId) from Auth service
  getMicrosoftIds() {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
    };
    const url = this.loginUrl + "/api/auth/get-microsoft-ids";
    return this.http.get(url, options);
  }

  loginMicrosoft(parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
      withCredentials: true
    };

    var url = this.loginUrl + "/api/auth/microsoft-login";
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  loginGoogle(parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
      withCredentials: true
    };

    var url = this.loginUrl + "/api/auth/google-login";
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  loginXero(parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
      withCredentials: true
    };

    var url = this.loginUrl + "/api/auth/xero-login";
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  loginXeroCompany(parameters: object, company: string) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": company,
      }),
      withCredentials: true
    };

    var url = this.loginUrl + "/api/auth/xero-login";
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  passwordReset(parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
    };

    var url = this.loginUrl + "/api/auth/password-reset";
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  passwordUpdate(parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
    };

    var url = this.loginUrl + "/api/auth/password-update";
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  passwordResetCheck(parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
    };

    var url = this.loginUrl + "/api/auth/password-reset-check";
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  postNoCompany(action: string, parameters: object) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    var url = this.apiUrl + action;
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  postCustomCompany(action: string, parameters: object, companyName: string) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": companyName,
      }),
    };

    var url = this.apiUrl + action;
    return this.http.post(url, JSON.stringify(parameters), options);
  }

  public async getUsersMention() {
    var result: any = await this.getSync("Lookup/GetUsersMention", null);
    return result.UsersMention;
  }

  public async TaskMarkComplete(task) {
    var result = await this.postSync("Activity/ActivityComplete", task);
    return result;
  }

  /*=================================================================
New HTTP Requests
================================================================*/
  private HttpOptions: any = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      "company-name": this.getCompanyName(),
    }),
  };

  // JM: Used to post formData asynchronously
  public async postSyncformData(action: string, parameters: object) {
    var options = {
      headers: new HttpHeaders({
        "company-name": this.getCompanyName(),
      }),
    };

    let return_response = new ResponseModel();

    try {
      AppState.pagesLoading = true;

      return_response = Object.assign(
        return_response,
        await this.http
          .post(this.apiUrl + "/api/" + action, parameters, options)
          .toPromise()
      );

      AppState.pagesLoading = false;
    } catch (exception) {
      AppState.pagesLoading = false;
      return_response = await this.handle_exception(exception, return_response);
    }

    DataService.ResponseEmitter.emit(return_response);

    return return_response;
  }

  //AB: This post_sync assumes that an interface is implemented that should return an response model
  //We await for the response (synchronous) where previously we had to pass the http call back which we then subscribed to.
  public async postSync(
    action: string,
    parameters: object,
    showloading: boolean = false
  ) {
    var options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
    };

    let return_response = new ResponseModel();

    try {
      if (showloading) AppState.pagesLoading = true;

      return_response = Object.assign(
        return_response,
        await this.http
          .post(
            this.apiUrl + "/api/" + action,
            JSON.stringify(parameters),
            options
          )
          .toPromise()
      );

      AppState.pagesLoading = false;
    } catch (exception) {
      AppState.pagesLoading = false;
      return_response = await this.handle_exception(exception, return_response);
    }

    DataService.ResponseEmitter.emit(return_response);

    return return_response;
  }

  //AB: This post_sync assumes that an interface is implemented that should return an response model
  //We await for the response (synchronous) where previously we had to pass the http call back which we then subscribed to.
  public async getSync(action: string, params: HttpParams) {
    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
      params: params,
    };

    let return_response = new ResponseModel();

    try {
      AppState.pagesLoading = true;
      return_response = Object.assign(
        return_response,
        await this.http.get(this.apiUrl + "/api/" + action, options).toPromise()
      );

      AppState.pagesLoading = false;
    } catch (exception) {
      AppState.pagesLoading = false;
      return_response = await this.handle_exception(exception, return_response);
    }

    DataService.ResponseEmitter.emit(return_response);

    return return_response;
  }

  public async getSyncId(action: string, id: any) {
    return this.getSync(action, new HttpParams().set("id", id));
  }

  //Handle the exceptions received from the http calls.
  //Add more exception types to this function and it will automatically filter up.
  private async handle_exception(exception, return_response: ResponseModel) {
    return_response.IsException = true;
    return_response.ShowError = true;

    try {
      if ((exception.name = "HttpErrorResponse")) {
        //BadRequest - so we fetch the returned data from the api that is in the BadRequest Object
        //We dig into the exception and assign it to our response model. Value = the model being returned from C#
        if (exception.status == 400) {
          return_response = Object.assign(return_response, exception.error);
        }
        //Status 0 when can't communicate with the API, we do a PING to the API just to confirm and send back relevent message.
        else if (exception.status == 0) {
          return_response.ErrorList.push(exception.message);
          return_response.ErrorList.push(await this.ping());
        } else {
          return_response.ErrorList.push("Unknown Http Error");
        }
      }
      //Any other exceptions we just add to the error list
      else {
        return_response.ErrorList.push(exception.message);
      }
    } catch (e) {
      return_response.ErrorList.push(e.message);
    }

    return return_response;
  }

  getBlob<Blob>(action: string, params: HttpParams) {
    const requestOptions: Object = {
      headers: new HttpHeaders({
        "Content-Type": "video/x-ms-wmv",
        "company-name": this.getCompanyName(),
      }),
      responseType: "arraybuffer",
      params: params,
    };

    return this.http.get<Blob>(this.apiUrl + action, requestOptions);
  }

  importBlob<Blob>(action: string, params: object) {
    const requestOptions: Object = {
      headers: new HttpHeaders({ "company-name": this.getCompanyName() }),
      responseType: "arraybuffer",
    };

    return this.http.post<Blob>(this.apiUrl + action, params, requestOptions);
  }

  exportBlob<Blob>(action: string, params: object) {
    const requestOptions: Object = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": this.getCompanyName(),
      }),
      responseType: "arraybuffer",
    };

    return this.http.post<Blob>(
      this.apiUrl + action,
      JSON.stringify(params),
      requestOptions
    );
  }

  //JD:Used to post formData
  postformData(action: string, parameters: object) {
    //let options = {
    //  headers: new HttpHeaders({
    //    'Content-Type': 'multipart/form-data', 'company-name': this.getCompanyName()
    //  })
    //};

    let options = {
      headers: new HttpHeaders({
        "company-name": this.getCompanyName(),
      }),
    };

    return this.http.post(this.apiUrl + action, parameters, options);
  }

  // ============================================
  // Financials
  // ============================================

  getFinancialDocuments(criteria) {
    return this.post("/api/Finance/SelectFinancialDocuments", criteria);
  }

  getFinancialDocument(id) {
    return this.get(
      "/api/Finance/SelectFinancialDocument",
      new HttpParams().set("financialDocumentId", id)
    );
  }

  getFinancialDocumentItems(id) {
    return this.get(
      "/api/Finance/SelectFinancialDocumentItems",
      new HttpParams().set("invoiceId", id)
    );
  }

  saveFinancialDocument(financialDocument) {
    return this.post("/api/Finance/FinancialDocumentUpsert", financialDocument);
  }

  saveFinancialDocumentItems(financialDocumentItems) {
    return this.post(
      "/api/Finance/FinancialDocumentItemsUpsert",
      financialDocumentItems
    );
  }

  invoiceCreate(invoiceDto) {
    return this.post("/api/Finance/InvoiceCreate", invoiceDto);
  }

  // Project Budget
  selectProjectBudgets(jobId: number) { return this.get('/api/Finance/SelectProjectBudgets', new HttpParams().set('jobId', jobId)); }
  selectProjectBudget(projectBudgetId: number) { return this.get('/api/Finance/SelectProjectBudget', new HttpParams().set('projectBudgetId', projectBudgetId)); }
  projectBudgetUpsert(model: any) { return this.post('/api/Finance/ProjectBudgetUpsert', model); }
  projectBudgetDelete(id: number) { return this.post('/api/Finance/ProjectBudgetDelete', id as any); }
  selectProjectBudgetItems(projectBudgetId: number) { return this.get('/api/Finance/SelectProjectBudgetItems', new HttpParams().set('projectBudgetId', projectBudgetId)); }
  projectBudgetItemUpsert(model: any) { return this.post('/api/Finance/ProjectBudgetItemUpsert', model); }
  projectBudgetItemDelete(id: number) { return this.post('/api/Finance/ProjectBudgetItemDelete', id as any); }
  projectBudgetSubmit(id: number) { return this.post('/api/Finance/ProjectBudgetSubmit', id as any); }
  projectBudgetApprove(id: number) { return this.post('/api/Finance/ProjectBudgetApprove', id as any); }
  projectBudgetReject(dto: any) { return this.post('/api/Finance/ProjectBudgetReject', dto); }
  projectBudgetSetBaseline(id: number) { return this.post('/api/Finance/ProjectBudgetSetBaseline', id as any); }
  projectBudgetClone(id: number) { return this.post('/api/Finance/ProjectBudgetClone', id as any); }

  // Project Costs
  selectProjectCosts(jobId: number) { return this.get('/api/Finance/SelectProjectCosts', new HttpParams().set('jobId', jobId)); }
  projectCostUpsert(model: any) { return this.post('/api/Finance/ProjectCostUpsert', model); }
  projectCostDelete(id: number) { return this.post('/api/Finance/ProjectCostDelete', id as any); }
  selectExpenseClaims(criteria: any) { return this.post('/api/Finance/SelectExpenseClaims', criteria); }
  selectExpenseClaimsAdmin(criteria: any) { return this.post('/api/Finance/SelectExpenseClaimsAdmin', criteria); }
  expenseClaimSetApproval(model: any) { return this.post('/api/Finance/ExpenseClaimSetApproval', model); }
  expenseClaimSetReimbursement(model: any) { return this.post('/api/Finance/ExpenseClaimSetReimbursement', model); }

  // Budget vs Actual
  selectProjectBudgetVsActual(jobId: number) { return this.get('/api/Finance/SelectProjectBudgetVsActual', new HttpParams().set('jobId', jobId)); }
  selectProjectBudgetVsActualByPhase(jobId: number) { return this.get('/api/Finance/SelectProjectBudgetVsActualByPhase', new HttpParams().set('jobId', jobId)); }
  selectProjectBudgetItemVsActual(jobId: number, projectBudgetId: number) { return this.get('/api/Finance/SelectProjectBudgetItemVsActual', new HttpParams().set('jobId', jobId).set('projectBudgetId', projectBudgetId)); }

  getPmoProjectProfitability(criteria: any) { return this.post('/api/Finance/SelectPmoProjectProfitability', criteria); }

  // ============================================
  // ============================================
  // Forms
  // ============================================

  getFormDefinition(id) {
    return this.get(
      "/api/FormsEngine/GetFormDefinition",
      new HttpParams().set("id", id)
    );
  }

  getFormDefinitionForSubmit(urlCode) {
    return this.get(
      "/api/FormsEngine/GetFormDefinitionForSubmit",
      new HttpParams().set("urlCode", urlCode)
    );
  }

  sendPublicFormOtp(body: { PublicUrlCode: string; EmailAddress?: string; MobileNumber?: string; FirstName?: string; Surname?: string }) {
    return this.post("/api/FormsEngine/SendPublicFormOtp", body);
  }

  verifyPublicFormOtp(body: { PublicUrlCode: string; EmailAddress?: string; MobileNumber?: string; EmailCode?: string; MobileCode?: string }) {
    return this.post("/api/FormsEngine/VerifyPublicFormOtp", body);
  }

  getFormTemplateBlob(templateFileId: number) {
    const params = new HttpParams().set("templateFileId", String(templateFileId));
    return this.http.get(this.apiUrl + "/api/FormsEngine/DownloadFormTemplate", {
      params,
      responseType: "blob",
      headers: new HttpHeaders({
        "company-name": this.getCompanyName() || "",
      }),
    });
  }

  getFormSubmission(id) {
    return this.get(
      "/api/FormsEngine/GetFormSubmission",
      new HttpParams().set("id", id)
    );
  }

  getFormList() {
    return this.get("/api/FormsEngine/GetFormList", null);
  }

  getFieldTypes() {
    return this.get("/api/FormsEngine/GetFieldTypes", null);
  }

  formDefinitionCreate(formDefinition: any) {
    return this.post("/api/FormsEngine/FormDefinitionCreate", formDefinition);
  }

  formDefinitionSave(formDefinition: any) {
    return this.post("/api/FormsEngine/FormDefinitionSave", formDefinition);
  }

  formSubmit(formDefinition: any) {
    return this.post("/api/FormsEngine/SaveFormSubmission", formDefinition);
  }

   uploadFormFieldTemplate(formId: number, formSectionId: number, fieldId: number, file: File) {
    const formData = new FormData();
    formData.append('formId', formId.toString());
    formData.append('formSectionId', formSectionId.toString());
    formData.append('fieldId', fieldId.toString());
    formData.append('file', file, file.name);
    return this.postformData('/api/FormsEngine/UploadFormFieldTemplate', formData);
  }

  submitCustomForm(formDefinition: any) {
    return this.post("/api/FormsEngine/SubmitCustomForm", formDefinition);
  }

  invokeTrigger(trigger: any) {
    console.log("invokeTrigger", trigger);
    return this.post("/api/FormsEngine/InvokeTriggerFromTicket", trigger);
  }

  // ============================================
  // Integrations
  // ============================================

  getIntegrations() {
    return this.get("/api/Integration/GetIntegrations", null);
  }

  getXeroIntegration() {
    return this.get("/api/Integration/GetXeroIntegration", null);
  }

  upsertXeroConfig(item: any) {
    return this.post("/api/Integration/UpsertXeroConfig", item);
  }

  XeroCallbackConfig(item: any) {
    return this.postCustomCompany(
      "/api/Integration/XeroCallback",
      item,
      item.state
    );
  }

  XeroCallbackConfigCustomCompany(item: any, company: any) {


    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": company
      }),
    };

    var url = this.apiUrl + "/api/Integration/XeroCallback";
    return this.http.post(url, JSON.stringify(item), options);
  }

  XeroLoginCallbackConfigCustomCompany(item: any, company: any) {


    let options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "company-name": company
      }),
    };

    var url = this.apiUrl + "/api/Integration/XeroLoginCallback";
    return this.http.post(url, JSON.stringify(item), options);
  }

  XeroLoginCallbackConfig(item: any) {
    return this.post("/api/Integration/XeroLoginCallback", item);
  }

  PostToXero(invoiceDocumentId: any) {
    return this.post("/api/Integration/PostInvoicesToXero", invoiceDocumentId);
  }

  PostQuoteToXero(invoiceDocumentId: any) {
    return this.post("/api/Integration/PostQuotesToXero", invoiceDocumentId);
  }

  XeroRefreshToken() {
    return this.post("/api/Integration/XeroRefreshToken", {});
  }

  PostImportZeroClients() {
    return this.post("/api/Integration/PostImportZeroClients", {});
  }

  PostExportZeroClients() {
    return this.post("/api/Integration/PostExportZeroClients", {});
  }

  isXeroEnabled() {
    return this.get("/api/Integration/IsXeroEnabled", null);
  }

  getXeroItems() {
    return this.get("/api/Integration/GetXeroItems", null);
  }

  unlinkXero() {
    return this.post("/api/Integration/UnlinkXero", {});
  }

  // ============================================
  // CRM Dash
  // ============================================

  getCrmDashTotals(criteria) {
    return this.post("/api/CRM/GetDashTotals", criteria);
  }

  getCrmOverviewCharts(criteria) {
    return this.post("/api/CRM/GetOverviewCharts", criteria);
  }

  getDealsByStageChart(criteria) {
    return this.post("/api/CRM/GetDealsByStageChart", criteria);
  }

  PostExportSingleClient(payload: { clientId: number }) {
    return this.post("/api/Integration/PostExportSingleClient", payload);
  }
  // ============================================
  // Project Budgets
  // ============================================

  getProjectBudgetList(criteria) {
    return this.post("/api/Project/ProjectBudgetListGet", criteria);
  }

  saveProjectBudgetList(items) {
    return this.post("/api/Project/ProjectBudgetListSave", items);
  }

  // ============================================
  // PMO
  // ============================================

  getProjects(criteria) {
    return this.post("/api/Project/SelectProjects", criteria);
  }

  getPmoProjectsGantt(criteria) {
    return this.post("/api/Project/GetProjectPmoGantt", criteria);
  }

  getPmoOverview(criteria) {
    return this.post("/api/Project/PmoOverview", criteria);
  }

  getPmoOverviewCharts(criteria) {
    return this.post("/api/Project/PmoOverviewCharts", criteria);
  }

  getpmoProjectHealthTimeline(criteria) {
    return this.post("/api/Project/PmoProjectHealthTimeline", criteria);
  }

  getProjectsByStatus(criteria) {
    return this.post("/api/Project/ProjectsByStatus", criteria);
  }

  getProjectsByStage(criteria) {
    return this.post("/api/Project/ProjectsByStage", criteria);
  }

  getProjectsByCategory(criteria) {
    return this.post("/api/Project/ProjectsByCategory", criteria);
  }

  getProjectsByPM(criteria) {
    return this.post("/api/Project/ProjectsByPM", criteria);
  }

  getPmoRiskRegister(criteria) {
    return this.post("/api/Project/SelectRiskRegister", criteria);
  }

  getTimeSheets(criteria) {
    return this.post("/api/Project/GetTimeSheets", criteria);
  }

  getResourceUtilisation(criteria) {
    return this.post("/api/Project/GetResourceUtilisationReport", criteria);
  }

  getTaskListVm(criteria) {
    return this.post("/api/Project/TaskListGet", criteria);
  }


  getTasks(criteria) {
    return this.get("/api/Project/TasksGet", criteria);
  }



  getTasksV2(criteria) {
    return this.get("/api/Project/GetTasks", criteria);
  }

  getTasksPost(criteria) {
    return this.post("/api/Project/GetTasksPost", criteria);
  }

  //JB: Project Grid
  selectProjectsWithCustomFields(criteria) {
    return this.post("/api/Project/SelectProjectsWithCustomFields", criteria);
  }

  getProjectGrid(criteria) {
    return this.post("/api/Project/GetProjectGrid", criteria);
  }

  projectSave(project) {
    return this.post("/api/Project/ProjectSave", project);
  }

  activitySave(activity, callBack = null) {
    this.post("/api/Activity/ActivitySave", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "saveActivity");
      },
      (error) => {
        this.debugLog(error, "activitySave Post Error");
      }
    );
  }

  saveCriteria(criteria, callBack = null) {
    this.post("/api/Project/SaveCriteria", criteria).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "SaveCriteria");
      },
      (error) => {
        this.debugLog(error, "SaveCriteria Post Error");
      }
    );
  }

  ticketSave(ticket, callBack = null) {
    this.post("/api/Ticket/TicketUpsert", ticket).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ticketSave");
      },
      (error) => {
        this.debugLog(error, "activitySave Post Error");
      }
    );
  }

  ticketResolve(ticket, callBack = null) {
    this.post("/api/Ticket/TicketResolve", ticket).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ticketSave");
      },
      (error) => {
        this.debugLog(error, "activitySave Post Error");
      }
    );
  }

  newTicketSave(ticket, callBack = null) {
    this.post("/api/Ticket/TicketInsert", ticket).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
        this.debugLog(response, "newTicketSave");
      },
      (error) => {
        this.debugLog(error, "newTicketSave Post Error");
      }
    );
  }

  ticketUserUpsert(item, callBack = null) {
    this.post("/api/Ticket/TicketUserUpsert", item).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ticketUserUpsert");
      },
      (error) => {
        this.debugLog(error, "ticketUserUpsert Post Error");
      }
    );
  }

  jobUserUpsert(item, callBack = null) {
    this.post("/api/Job/JobUserUpsert", item).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "JobUserUpsert");
      },
      (error) => {
        this.debugLog(error, "JobUserUpsert Post Error");
      }
    );
  }

  taskSpaceUserUpsert(item, callBack = null) {
    this.post("/api/Spaces/TaskSpaceUserUpsert", item).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "TaskSpaceUserUpsert");
      },
      (error) => {
        this.debugLog(error, "TaskSpaceUserUpsert Post Error");
      }
    );
  }

  ticketClick(id) {
    var ticket: any = {};
    ticket.TicketId = id;

    this.post("/api/Ticket/TicketClick", ticket).subscribe(
      (response: any) => {
        this.debugLog(response, "ticketClick");
      },
      (error) => {
        this.debugLog(error, "ticketClick Post Error");
      }
    );
  }

  ticketFollow(ticket) {
    this.post("/api/Ticket/TicketFollow", ticket).subscribe(
      (response: any) => {
        this.debugLog(response, "TicketFollow");
      },
      (error) => {
        this.debugLog(error, "TicketFollow Post Error");
      }
    );
  }

  ticketUnFollow(ticket) {
    this.post("/api/Ticket/TicketUnFollow", ticket).subscribe(
      (response: any) => {
        this.debugLog(response, "TicketUnFollow");
      },
      (error) => {
        this.debugLog(error, "TicketFollow Post Error");
      }
    );
  }

  ticketFavourite(ticket) {
    this.post("/api/Ticket/TicketFavourite", ticket).subscribe(
      (response: any) => {
        this.debugLog(response, "TicketFavourite");
      },
      (error) => {
        this.debugLog(error, "TicketFavourite Post Error");
      }
    );
  }

  ticketUnFavourite(ticket) {
    this.post("/api/Ticket/TicketUnFavourite", ticket).subscribe(
      (response: any) => {
        this.debugLog(response, "TicketUnFavourite");
      },
      (error) => {
        this.debugLog(error, "TicketUnFavourite Post Error");
      }
    );
  }

  ticketClick2(ticket) {
    this.post("/api/Ticket/TicketClick", ticket).subscribe(
      (response: any) => {
        this.debugLog(response, "ticketClick");
      },
      (error) => {
        this.debugLog(error, "ticketClick Post Error");
      }
    );
  }

  ticketGet(id, callBack = null) {
    this.get("/api/Ticket/TicketGet", new HttpParams().set("id", id)).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ticketGet");
      },
      (error) => {
        this.debugLog(error, "ticketGet Get Error");
      }
    );
  }

  ticketGet2(criteria, callBack = null) {
    this.post("/api/Ticket/TicketGet2", criteria).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
        this.debugLog(response, "ticketGet");
      },
      (error) => {
        this.debugLog(error, "ticketGet Get Error");
      }
    );
  }

  ticketUserGet(id, callBack = null) {
    this.get(
      "/api/Ticket/TicketUserSelect",
      new HttpParams().set("id", id)
    ).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "TicketUserSelect");
      },
      (error) => {
        this.debugLog(error, "TicketUserSelect Get Error");
      }
    );
  }

  jobUserGet(id, callBack = null) {
    this.get(
      "/api/Job/JobUserSelect",
      new HttpParams().set("id", id)
    ).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "JobUserSelect");
      },
      (error) => {
        this.debugLog(error, "JobUserSelect Get Error");
      }
    );
  }

  commentsGet(entityName, recordId, callBack = null) {
    this.post("/api/Data/GetComments", {
      EntityName: entityName,
      RecordId: recordId,
    }).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "getComments");
      },
      (error) => {
        this.debugLog(error, "getComments Post Error");
      }
    );
  }

  commentsGetV2(
    entityName,
    recordId,
    secondaryEntity,
    secondaryEntityId,
    callBack = null
  ) {
    this.post("/api/Data/GetComments", {
      EntityName: entityName,
      RecordId: recordId,
      SecondaryEntityName: secondaryEntity,
      SecondaryEntityId: secondaryEntityId,
    }).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "getComments");
      },
      (error) => {
        this.debugLog(error, "getComments Post Error");
      }
    );
  }

  commentsGetV3(entityName, recordId, secondaryEntity, secondaryEntityId, callBack = null) {
    this.post("/api/Data/GetCommentsV3", {
      EntityName: entityName,
      RecordId: recordId,
      SecondaryEntityName: secondaryEntity,
      SecondaryEntityId: secondaryEntityId
    }).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "getComments");
      },
      (error) => {
        this.debugLog(error, "getComments Post Error");
      }
    );
  }

  getCommentHeader(entityName, recordId, secondaryEntity, secondaryEntityId, callBack = null) {
    this.post("/api/Data/GetCommentHeader", {
      EntityName: entityName,
      RecordId: recordId,
      SecondaryEntityName: secondaryEntity,
      SecondaryEntityId: secondaryEntityId
    }).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "getComments");
      },
      (error) => {
        this.debugLog(error, "getComments Post Error");
      }
    );
  }


  commentSave(comment, callBack = null) {
    this.post("/api/Data/SaveComment", comment).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
        this.debugLog(response, "SaveComment");
      },
      (error) => {
        this.debugLog(error, "SaveComment Post Error");
      }
    );
  }

  commentDelete(commentId, allowDelete, callBack = null) {
    this.get(
      "/api/Data/CommentDelete",
      new HttpParams()
        .set("commentId", commentId)
        .set("allowDelete", allowDelete)
    ).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "Comment Delete");
      },
      (error) => {
        this.debugLog(error, "Comment Delete Post Error");
      }
    );
  }

  ticketGetActivity(ticket, callBack = null) {
    this.post("/api/Ticket/TicketGetActivity", ticket).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ticketGetActivity");
      },
      (error) => {
        this.debugLog(error, "ticketGetActivity Post Error");
      }
    );
  }

  ticketDelete(ticket, callBack = null) {
    this.post("/api/Ticket/TicketDelete", ticket).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ticketDelete");
      },
      (error) => {
        this.debugLog(error, "ticketDelete Post Error");
      }
    );
  }

  ticketSendMail(mail, callBack = null) {
    this.post("/api/Ticket/SendMail", mail).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ticketSendMail");
      },
      (error) => {
        this.debugLog(error, "ticketSendMail Post Error");
      }
    );
  }

  NewActivityStartWorkingOn(activity, callBack = null) {
    this.post("/api/Activity/NewActivityStartWorkingOn", activity).subscribe(
      (response: any[]) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "NewActivityStartWorkingOn");
      },
      (error) => {
        this.debugLog(error, "NewActivityStartWorkingOn Post Error");
      }
    );
  }

  activityArchive(activity, callBack = null) {
    this.post("/api/Activity/ActivityArchive", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "activityArchive Post Error");
      }
    );
  }

  async activityDuplicate(activity) {
    return await this.postSync("Activity/DuplicateTask", activity);
  }

  async activityDuplicateMulti(activities) {
    return await this.postSync("Activity/DuplicateTasks", activities);
  }

  async ticketCategoryDuplicate(category) {
    return await this.postSync("Ticket/DuplicateTicketCategory", category);
  }

  NewActivity(activity, callBack = null) {
    this.post("/api/Activity/NewActivity", activity).subscribe(
      (response: any[]) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "NewActivity");
      },
      (error) => {
        this.debugLog(error, "NewActivity Post Error");
      }
    );
  }

  activityGet(id, callBack = null) {
    this.get(
      "/api/Activity/ActivityGet",
      new HttpParams().set("activityId", id)
    ).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "activityGet");
      },
      (error) => {
        this.debugLog(error, "activityGet Post Error");
      }
    );
  }

  activityGetFull(id, callBack = null) {
    this.get(
      "/api/Activity/ActivityGetFull",
      new HttpParams().set("activityId", id)
    ).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "activityGet");
      },
      (error) => {
        this.debugLog(error, "activityGet Post Error");
      }
    );
  }

  activityContentGet(id, callback = null) {
    this.get(
      "/api/Activity/ActivityContentGet",
      new HttpParams().set("activityId", id)
    ).subscribe(
      (response: any) => {
        callback(response);
      },
      (error) => {
        this.debugLog(error, "update Job Post Error");
      }
    );
  }

  jobContentGet(id, callback = null) {
    this.get(
      "/api/Job/JobContentGet",
      new HttpParams().set("jobId", id)
    ).subscribe(
      (response: any) => {
        callback(response);
      },
      (error) => {
        this.debugLog(error, "jobContentGet Error");
      }
    );
  }

  clientContentGet(id, callback = null) {
    this.get(
      "/api/Client/ClientContentGet",
      new HttpParams().set("clientId", id)
    ).subscribe(
      (response: any) => {
        callback(response);
      },
      (error) => {
        this.debugLog(error, "ClientContentGet Error");
      }
    );
  }

  ticketContentGet(id, callback = null) {
    this.get(
      "/api/Ticket/TicketContentGet",
      new HttpParams().set("ticketId", id)
    ).subscribe(
      (response: any) => {
        callback(response);
      },
      (error) => {
        this.debugLog(error, "ticketContentGet Error");
      }
    );
  }

  activityDelete(activity, callBack = null) {
    this.post("/api/Activity/ActivityDelete", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ActivityDelete");
      },
      (error) => {
        this.debugLog(error, "activitySave Post Error");
      }
    );
  }

  testCallback(a, callBack = null) {
    callBack(a);
  }

  activityFollow(activity, callBack = null) {
    this.post("/api/Activity/ActivityFollow", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ActivityFollow");
      },
      (error) => {
        this.debugLog(error, "ActivityFollow Post Error");
      }
    );
  }

  activityLike(activity, callBack = null) {
    this.post("/api/Activity/ActivityLike", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ActivityLike");
      },
      (error) => {
        this.debugLog(error, "ActivityLike Post Error");
      }
    );
  }

  activityLeave(activity, callBack = null) {
    this.post("/api/Activity/ActivityLeave", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ActivityFollow");
      },
      (error) => {
        this.debugLog(error, "ActivityFollow Post Error");
      }
    );
  }

  activityTag(activityId, tagId, callBack = null) {
    this.post("/api/Activity/ActivityTag", {
      ActivityId: activityId,
      TagId: tagId,
    }).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ActivityFollow");
      },
      (error) => {
        this.debugLog(error, "ActivityFollow Post Error");
      }
    );
  }

  activityTimeSheetSave(timeSheet, callback = null) {
    this.post("/api/Activity/ActivityTimesheetUpsert", timeSheet).subscribe(
      (response: any) => {
        this.debugLog(response, "ActivityTimesheetsUpsert");

        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "ActivityTimesheetsUpsert Post Error");
      }
    );
  }

  activityTimeSheetsSave(timeSheets, callback = null) {
    this.post("/api/Activity/ActivityTimesheetsUpsert", timeSheets).subscribe(
      (response: any) => {
        this.debugLog(response, "ActivityTimesheetsUpsert");

        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "ActivityTimesheetsUpsert Post Error");
      }
    );
  }

  activityTasksSave(tasks, callback = null) {
    this.post("/api/Activity/ActivityTasksUpsert", tasks).subscribe(
      (response: any) => {
        this.debugLog(response, "activityTasksSave");

        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "activityTasksSave Post Error");
      }
    );
  }

  GetCurrentlyWorkingOn(callBack = null) {
    this.post("/api/Activity/GetCurrentlyWorkingOn", null).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "GetCurrentlyWorkingOn");
      },
      (error) => {
        this.debugLog(error, "GetCurrentlyWorkingOn Post Error");
      }
    );
  }

  activityStartWorkingOn(activity, callBack = null) {
    this.post("/api/Activity/ActivityStartWorkingOn", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "activityStartWorkingOn");
      },
      (error) => {
        this.debugLog(error, "activityStartWorkingOn Post Error");
      }
    );
  }

  activityStopWorkingOn(activity, callBack = null) {
    this.post("/api/Activity/ActivityStopWorkingOn", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "activityStopWorkingOn");
      },
      (error) => {
        this.debugLog(error, "activityStopWorkingOn Post Error");
      }
    );
  }

  activityPauseWorkingOn(activity, callBack = null) {
    this.post("/api/Activity/ActivityPauseWorkingOn", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "activityPauseWorkingOn");
      },
      (error) => {
        this.debugLog(error, "activityPauseWorkingOn Post Error");
      }
    );
  }

  activityResumeWorkingOn(activity, callBack = null) {
    this.post("/api/Activity/ActivityResumeWorkingOn", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "ActivityResumeWorkingOn");
      },
      (error) => {
        this.debugLog(error, "ActivityResumeWorkingOn Post Error");
      }
    );
  }

  jobCreate(model, callback = null) {
    this.post("/api/Activity/JobCreate", model).subscribe(
      (response: any) => {
        this.debugLog(response, "jobCreate");

        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "ActivityTimesheetsUpsert Post Error");
      }
    );
  }

  jobCopy(model, callback = null) {
    this.post("/api/Activity/JobCopy", model).subscribe(
      (response: any) => {
        this.debugLog(response, "jobCopy");

        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "Job Post Error");
      }
    );
  }

  activitySortOrderUpdate(activityId, sortOrder) {
    this.post("/api/Activity/ActivitySortOrderUpdate", {
      activityId: activityId,
      sortOrder: sortOrder,
    }).subscribe(
      (response: any) => { },
      (error) => {
        this.debugLog(error, "ActivitySortOrderUpdate Post Error");
      }
    );
  }

  async activityWbsSortOrderUpdate(activityId, sortOrder) {
    await this.post("/api/Activity/ActivityWbsSortOrderUpdate", {
      activityId: activityId,
      sortOrder: sortOrder,
    }).subscribe(
      (response: any) => { },
      (error) => {
        this.debugLog(error, "ActivityWbsSortOrderUpdate Post Error");
      }
    );
  }

  jobSave(job, callBack = null) {
    this.post("/api/Job/JobSave", job).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "jobSave");
      },
      (error) => {
        this.debugLog(error, "jobSave Post Error");
      }
    );
  }

  jobSavePhases(phases, callBack = null) {
    this.post("/api/Job/JobPhasesSave", phases).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "JobPhasesSave");
      },
      (error) => {
        this.debugLog(error, "JobPhasesSave Post Error");
      }
    );
  }

  jobSaveSprints(sprints, callBack = null) {
    this.post("/api/Job/JobSprintsSave", sprints).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "JobSprintsSave");
      },
      (error) => {
        this.debugLog(error, "JobSprintsSave Post Error");
      }
    );
  }

  jobSavePurchaseOrders(purchaseOrders, callBack = null) {
    this.post("/api/Job/JobPurchaseOrderSave", purchaseOrders).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "JobPurchaseOrders Save");
      },
      (error) => {
        this.debugLog(error, "JobPurchaseOrders Post Error");
      }
    );
  }

  jobStatusUpdate(job) {
    this.post("/api/Job/JobStatusUpdate", job).subscribe(
      (response: any) => {
        this.debugLog(response, "jobStatusUpdate");
      },
      (error) => {
        this.debugLog(error, "jobStatusUpdate Post Error");
      }
    );
  }

  JobStageUpdate(job) {
    this.post("/api/Job/JobStageUpdate", job).subscribe(
      (response: any) => {
        this.debugLog(response, "JobStageUpdate");
      },
      (error) => {
        this.debugLog(error, "JobStageUpdate Post Error");
      }
    );
  }

  JobCategoryUpdate(job) {
    this.post("/api/Job/JobCategoryUpdate", job).subscribe(
      (response: any) => {
        this.debugLog(response, "JobCategoryUpdate");
      },
      (error) => {
        this.debugLog(error, "JobCategoryUpdate Post Error");
      }
    );
  }

  JobBillingTypeUpdate(job) {
    this.post("/api/Job/JobBillingTypeUpdate", job).subscribe(
      (response: any) => {
        this.debugLog(response, "JobBillingTypeUpdate");
      },
      (error) => {
        this.debugLog(error, "JobBillingTypeUpdate Post Error");
      }
    );
  }

  JobProjectManagerUpdate(job) {
    this.post("/api/Job/JobProjectManagerUpdate", job).subscribe(
      (response: any) => {
        this.debugLog(response, "JobProjectManagerUpdate");
      },
      (error) => {
        this.debugLog(error, "JobProjectManagerUpdate Post Error");
      }
    );
  }

  JobTechLeadUpdate(job) {
    this.post("/api/Job/JobTechLeadUpdate", job).subscribe(
      (response: any) => {
        this.debugLog(response, "JobTechLeadUpdate");
      },
      (error) => {
        this.debugLog(error, "JobTechLeadUpdate Post Error");
      }
    );
  }

  activityStatusUpdate(activity) {
    this.post("/api/Activity/ActivityStatusUpdate", activity).subscribe(
      (response: any) => {
        this.debugLog(response, "ActivityStatusUpdate");
      },
      (error) => {
        this.debugLog(error, "ActivityStatusUpdate Post Error");
      }
    );
  }

  activityCategoryUpdate(activity) {
    this.debugLog(activity, "Activity");
    this.post("/api/Activity/ActivityCategoryUpdate", activity).subscribe(
      (response: any) => {
        this.debugLog(response, "ActivityCategoryUpdate");
      },
      (error) => {
        this.debugLog(error, "ActivityStatusUpdate Post Error");
      }
    );
  }

  activityUserUpdate(activity) {
    this.debugLog(activity, "Activity");
    this.post("/api/Activity/ActivityUserUpdate", activity).subscribe(
      (response: any) => {
        this.debugLog(response, "ActivityUserUpdate");
      },
      (error) => {
        this.debugLog(error, "ActivityUserUpdate Post Error");
      }
    );
  }

  activityPriorityUpdate(activity) {
    this.debugLog(activity, "Activity");
    this.post("/api/Activity/ActivityPriorityUpdate", activity).subscribe(
      (response: any) => {
        this.debugLog(response, "ActivityUserUpdate");
      },
      (error) => {
        this.debugLog(error, "ActivityUserUpdate Post Error");
      }
    );
  }

  activityJobPhaseUpdate(activity) {
    this.debugLog(activity, "Activity");
    this.post("/api/Activity/ActivityJobPhaseUpdate", activity).subscribe(
      (response: any) => {
        this.debugLog(response, "ActivityUserUpdate");
      },
      (error) => {
        this.debugLog(error, "ActivityUserUpdate Post Error");
      }
    );
  }

  activityProjectMilestoneUpdate(activity) {
    this.debugLog(activity, "Activity");
    this.post(
      "/api/Activity/ActivityProjectMilestoneUpdate",
      activity
    ).subscribe(
      (response: any) => {
        this.debugLog(response, "activityProjectMilestoneUpdate");
      },
      (error) => {
        this.debugLog(error, "activityProjectMilestoneUpdate Post Error");
      }
    );
  }

  activityJobSprintUpdate(activity) {
    this.debugLog(activity, "Activity");
    this.post("/api/Activity/ActivityJobSprintUpdate", activity).subscribe(
      (response: any) => {
        this.debugLog(response, "ActivityUserUpdate");
      },
      (error) => {
        this.debugLog(error, "ActivityUserUpdate Post Error");
      }
    );
  }

  activityTeamSprintUpdate(activity) {
    this.debugLog(activity, "Activity");
    this.post("/api/Activity/ActivityTeamSprintUpdate", activity).subscribe(
      (response: any) => {
        this.debugLog(response, "ActivityUserUpdate");
      },
      (error) => {
        this.debugLog(error, "ActivityUserUpdate Post Error");
      }
    );
  }

  activityDueDateUpdate(activity, callBack = null) {
    this.debugLog(activity, "Activity");
    this.post("/api/Activity/ActivityDueDateUpdate", activity).subscribe(
      (response: any) => {
        if (callBack != null) callBack(response);
        this.debugLog(response, "ActivityUserUpdate");
      },
      (error) => {
        this.debugLog(error, "ActivityUserUpdate Post Error");
      }
    );
  }

  async JobStartDateUpdate(job) {
    this.debugLog(job, "Job");
    var response = await this.postSync("Job/JobStartDateUpdate", job);
    this.debugLog(response, "JobStartDateUpdate");
  }

  async JobEndDateUpdate(job) {
    this.debugLog(job, "Job");
    var response = await this.postSync("Job/JobEndDateUpdate", job);
    this.debugLog(response, "JobEndDateUpdate");
  }

  async JobDueDateUpdate(job) {
    this.debugLog(job, "Job");
    var response = await this.postSync("Job/JobDueDateUpdate", job);
    this.debugLog(response, "JobDueDateUpdate");
  }

  criteriaSave(criteria) {
    this.post("/api/Activity/CriteriaSave", criteria).subscribe(
      (response: any) => {
        this.debugLog(response, "criteriaSave");
      },
      (error) => {
        this.debugLog(error, "activitySave Post Error");
      }
    );
  }

  sortActivitiesById(ids, callback = null) {
    this.post("/api/Activity/ActivitySortIds", ids).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "sortAllItems Error");
      }
    );
  }

  sortActivityTimeSheetsById(ids, callback = null) {
    this.post("/api/Activity/ActivityTimeSheetSortIds", ids).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "ActivityTimeSheetSortIds Error");
      }
    );
  }

  // ===========================================================================
  // Task editor API (task-slider / task-edit-full). Mirrors the activity* methods
  // but targets the new /api/Task/* endpoints. Both the task-slider and
  // task-edit-full surfaces use these so changes apply to both.
  // ===========================================================================

  taskGet(id, callBack = null) {
    this.get(
      "/api/Task/TaskGet",
      new HttpParams().set("activityId", id)
    ).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
        this.debugLog(response, "taskGet");
      },
      (error) => {
        this.debugLog(error, "taskGet Error");
      }
    );
  }

  taskGetFull(id, callBack = null) {
    this.get(
      "/api/Task/TaskGetFull",
      new HttpParams().set("activityId", id)
    ).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
        this.debugLog(response, "taskGetFull");
      },
      (error) => {
        this.debugLog(error, "taskGetFull Error");
      }
    );
  }

  taskContentGet(id, callback = null) {
    this.get(
      "/api/Task/TaskContentGet",
      new HttpParams().set("activityId", id)
    ).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskContentGet Error");
      }
    );
  }

  taskSave(activity, callBack = null) {
    this.post("/api/Task/TaskSave", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskSave Error");
      }
    );
  }

  // Meeting / Calendar Invite (RY-034063)
  taskMeetingSave(activity, callBack = null) {
    this.post("/api/Task/TaskMeetingSave", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskMeetingSave Error");
      }
    );
  }

  taskMeetingSendInvite(activityId, callBack = null) {
    this.post("/api/Task/TaskMeetingSendInvite", { ActivityId: activityId }).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskMeetingSendInvite Error");
      }
    );
  }

  taskMeetingCancel(activityId, callBack = null) {
    this.post("/api/Task/TaskMeetingCancel", { ActivityId: activityId }).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskMeetingCancel Error");
      }
    );
  }

  taskMeetingAttendeeDelete(activityMeetingAttendeeId, callBack = null) {
    this.post("/api/Task/TaskMeetingAttendeeDelete", { ActivityMeetingAttendeeId: activityMeetingAttendeeId }).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskMeetingAttendeeDelete Error");
      }
    );
  }

  // Server-side filtered task list (new task-list component). Returns the
  // observable directly so the caller can subscribe for both the initial
  // load and per-parent child expansions.
  taskList(criteria: any) {
    return this.post("/api/Task/TaskList", criteria);
  }

  taskDelete(activity, callBack = null) {
    this.post("/api/Task/TaskDelete", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskDelete Error");
      }
    );
  }

  taskArchive(activity, callBack = null) {
    this.post("/api/Task/TaskArchive", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskArchive Error");
      }
    );
  }

  async taskDuplicate(activity) {
    return await this.postSync("Task/TaskDuplicate", activity);
  }

  taskTimeSheetSave(timeSheet, callback = null) {
    this.post("/api/Task/TaskTimeSheetSave", timeSheet).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskTimeSheetSave Error");
      }
    );
  }

  taskTimeSheetsSave(timeSheets, callback = null) {
    this.post("/api/Task/TaskTimeSheetsSave", timeSheets).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskTimeSheetsSave Error");
      }
    );
  }

  taskTimeSheetDelete(timeSheet, callback = null) {
    this.post("/api/Task/TaskTimeSheetDelete", timeSheet).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskTimeSheetDelete Error");
      }
    );
  }

  sortTaskTimeSheetsById(ids, callback = null) {
    this.post("/api/Task/TaskTimeSheetSortIds", ids).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "TaskTimeSheetSortIds Error");
      }
    );
  }

  taskStartWorkingOn(activity, callBack = null) {
    this.post("/api/Task/TaskStartWorkingOn", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskStartWorkingOn Error");
      }
    );
  }

  taskStopWorkingOn(activity, callBack = null) {
    this.post("/api/Task/TaskStopWorkingOn", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskStopWorkingOn Error");
      }
    );
  }

  taskGetCurrentlyWorkingOn(callBack = null) {
    this.post("/api/Task/TaskGetCurrentlyWorkingOn", null).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskGetCurrentlyWorkingOn Error");
      }
    );
  }

  taskCommentInsert(comment, callBack = null) {
    this.post("/api/Task/TaskCommentInsert", comment).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskCommentInsert Error");
      }
    );
  }

  taskFollow(activity, callBack = null) {
    this.post("/api/Task/TaskFollow", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskFollow Error");
      }
    );
  }

  taskLike(activity, callBack = null) {
    this.post("/api/Task/TaskLike", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskLike Error");
      }
    );
  }

  taskLeave(activity, callBack = null) {
    this.post("/api/Task/TaskLeave", activity).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "taskLeave Error");
      }
    );
  }

  sortJobPhases(ids, callback = null) {
    this.post("/api/Job/SortJobPhases", ids).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "SortJobPhases Error");
      }
    );
  }

  sortProjectMilestones(ids, callback = null) {
    this.post("/api/Job/SortProjectMilestones", ids).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "SortJobPhases Error");
      }
    );
  }

  sortJobSprints(ids, callback = null) {
    this.post("/api/Job/SortJobSprints", ids).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "SortJobSprints Error");
      }
    );
  }

  spaceUserSort(ids, callback = null) {
    this.post("/api/Spaces/SpacesUserSort", ids).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "SpacesUserSort Error");
      }
    );
  }

  sortJobUser(ids, callback = null) {
    this.post("/api/Job/JobUserSort", ids).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "JobUserSort Error");
      }
    );
  }

  ActivityDeleteMulti(ids, callback = null) {
    this.post("/api/Activity/ActivityDeleteMulti", ids).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "ActivityDeleteMulti Error");
      }
    );
  }

  activityArchiveMulti(ids, callback = null) {
    this.post("/api/Activity/ActivityDeleteMulti", {
      Activities: ids,
    }).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "activityArchiveMulti Error");
      }
    );
  }

  clientSave(client, callback = null) {
    this.post("/api/Client/PostClient", client).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "Client Post Error");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  // Author: Junior Malaza
  // Created Date: 14-07-2022
  supplierSave(supplier, callback = null) {
    this.post("/api/Supplier/PostSupplier", supplier).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "Supplier Post Error");
        if (callback != null) {
          callback();
        }
      }
    );
  }

  contactSave(contact, callback = null) {
    this.post("/api/Contact/SaveContact", contact).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "Client Post Error");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  contactDelete(id, callback = null) {
    this.post("/api/Contact/ContactDelete", id).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "Client Post Error");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  clientDelete(id, callback = null) {
    this.post("/api/Activity/ClientDelete", id).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "Client Delete Error");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  supplierDelete(id, callback = null) {
    this.post("/api/Activity/SupplierDelete", id).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "Supplier Delete Error");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  jobDelete(job, callback = null) {
    this.post("/api/Activity/JobDelete", job).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "Job Delete Error");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  jobFavourite(job, callback = null) {
    this.post("/api/Job/JobFavourite", job).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "jobFavourite Error");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  jobUnFavourite(job, callback = null) {
    this.post("/api/Job/JobUnFavourite", job).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "jobFavourite Error");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  jobUnFavouriteAll(callback = null) {
    this.post("/api/Job/JobUnFavouriteAll", null).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "JobUnFavouriteAll Error");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  notificationDismiss(id, callback = null) {
    this.post("/api/Notification/Dismiss", { notificationId: id }).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "notificationDismiss");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  notificationRead(id, callback = null) {
    this.post("/api/Notification/ReadNotification", { notificationId: id }).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "notificationRead");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  mailMessageRead(item, callback = null) {
    this.post("/api/Ticket/MailMessageRead", item).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "mailMessageRead");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  mailMessageUnRead(item, callback = null) {
    this.post("/api/Ticket/MailMessageUnRead", item).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "mailMessageUnRead");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  notificationShow(id, callback = null) {
    this.post("/api/Notification/Show", { notificationId: id }).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "notificationShow");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  notificationDismissAll(callback = null) {
    this.post("/api/Notification/DismissAll", null).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "notificationDismissAll");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  getSentEmail(id, callback = null) {
    this.get(
      "/api/Ticket/GetSentEmail",
      new HttpParams().set("ticketMailOutId", id)
    ).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "GetSentEmail");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  GetContactsFromString(contacts, callback = null) {
    this.get(
      "/api/Ticket/GetContactsFromString",
      new HttpParams().set("contacts", contacts)
    ).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "notificationDismissAll");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  ticketStatusUpdateMulti(ids, recordId, callback = null) {
    var parm = { TicketIds: ids, RecordId: recordId };

    this.post("/api/Ticket/TicketStatusUpdateMulti", parm).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "TicketStatusUpdateMulti Error");
      }
    );
  }

  ticketCategoryUpdateMulti(ids, recordId, callback = null) {
    var parm = { TicketIds: ids, RecordId: recordId };

    this.post("/api/Ticket/TicketMultiUpdateCategory", parm).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "TicketMultiUpdateCategory Error");
      }
    );
  }

  mailMessageAttachmentDelete(item, callback = null) {
    this.post("/api/Ticket/DeleteMailAttachment", item).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "mailMessageAttachmentDelete Error");
      }
    );
  }

  ticketAssignToMulti(ids, recordId, callback = null) {
    var parm = { TicketIds: ids, RecordId: recordId };

    this.post("/api/Ticket/TicketMultiAssignTo", parm).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "TicketMultiAssignTo Error");
      }
    );
  }

  ticketStarMulti(ids, recordId, callback = null) {
    var parm = { TicketIds: ids, RecordId: recordId };

    this.post("/api/Ticket/TicketStarMulti", parm).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "TicketStarMulti Error");
      }
    );
  }

  ticketUnStarMulti(ids, recordId, callback = null) {
    var parm = { TicketIds: ids, RecordId: recordId };

    this.post("/api/Ticket/TicketUnStarMulti", parm).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "TicketUnStarMulti Error");
      }
    );
  }

  ticketFollowMulti(ids, recordId, callback = null) {
    var parm = { TicketIds: ids, RecordId: recordId };

    this.post("/api/Ticket/TicketFollowMulti", parm).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "TicketFollowMulti Error");
      }
    );
  }

  ticketUnFollowMulti(ids, recordId, callback = null) {
    var parm = { TicketIds: ids, RecordId: recordId };

    this.post("/api/Ticket/TicketUnFollowMulti", parm).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "TicketUnFollowMulti Error");
      }
    );
  }

  ticketDeleteMulti(ids, callback = null) {
    var parm = { TicketIds: ids };

    this.post("/api/Ticket/TicketMultiDelete", parm).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "TicketMultiAssignTo Error");
      }
    );
  }

  ticketDueDateUpdateMulti(ids, date, callback = null) {
    var parm = { TicketIds: ids, Date: date };

    this.post("/api/Ticket/TicketMultiUpdateDueDate", parm).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "TicketMultiUpdateDueDate Error");
      }
    );
  }

  ticketCheckOpenMandatoryTasks(ticket, callBack = null) {
    this.post("/api/Ticket/TicketCheckOpenMandatoryTasks", ticket).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "ticketGetActivity Post Error");
      }
    );
  }

  loadUserFromCompany(id, callback = null) {
    this.get("/api/User/LoadUser", new HttpParams().set("id", id)).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "LoadUser");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  getTicketCategoryByCode(code: string, callback = null) {
    this.get(
      "/api/Ticket/LoadTicketCategoryByCode",
      new HttpParams().set("code", code)
    ).subscribe(
      (response: any) => {
        if (callback != null) {
          callback(response);
        }
      },
      (error) => {
        this.debugLog(error, "LoadTicketCategoryByCode");

        if (callback != null) {
          callback();
        }
      }
    );
  }

  // ============================================
  // WBS Methods
  // ============================================
  wbsUpdatePlannedEndDates(jobId, callBack = null) {
    this.post(
      "/api/Activity/WbsUpdatePlannedEndDates?jobId=" + jobId,
      null
    ).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "wbsUpdatePlannedEndDates");
      },
      (error) => {
        this.debugLog(error, "wbsUpdatePlannedEndDates Post Error");
      }
    );
  }

  wbsUpdateParentChildIndent(jobId, callBack = null) {
    this.post(
      "/api/Activity/WbsUpdateParentChildIndent?jobId=" + jobId,
      null
    ).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "WbsUpdateParentChildIndent");
      },
      (error) => {
        this.debugLog(error, "WbsUpdateParentChildIndent Post Error");
      }
    );
  }

  wbsUpdateResourcesFromResourceTypes(jobId, callBack = null) {
    this.post(
      "/api/Activity/WbsUpdateResourcesFromResourceTypes?jobId=" + jobId,
      null
    ).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }

        this.debugLog(response, "WbsUpdateResourcesFromResourceTypes");
      },
      (error) => {
        this.debugLog(error, "WbsUpdateResourcesFromResourceTypes Post Error");
      }
    );
  }

  // ============================================
  // Onboarding Methods
  // ============================================
  onboardClient(model, callBack = null) {
    this.post("/api/TR_Lead/OnboardClient", model).subscribe(
      (response: any) => {
        if (callBack != null) {
          callBack(response);
        }
      },
      (error) => {
        this.debugLog(error, "onboardClient Post Error");
      }
    );
  }

  async getProjectStatusLogList(jobId = 0) {
    return await this.getSync(
      "Job/GetProjectStatusLogList",
      new HttpParams().set("jobId", jobId)
    );
  }

  getProjectStatusChangeLogList(jobId = 0) {
    return this.get(
      "Project/GetProjectStatusChangeLog",
      new HttpParams().set("jobId", jobId)
    );
  }

  async getProjectStatusLog(projectStatusLogId = 0, jobId) {
    return await this.getSync(
      "Job/GetProjectStatusLog",
      new HttpParams()
        .set("projectStatusLogId", projectStatusLogId)
        .set("jobId", jobId)
    );
  }

  async updateProjectStatus(projectStatus) {
    return await this.postSync("Job/UpdateProjectStatus", projectStatus);
  }

  // ============================================
  // Billing Timesheets Methods
  // ============================================
  billingTimesheetsSelect(criteria: any) {
    return this.post("/api/Project/SelectBillingTimesheets", criteria);
  }

  billingTimesheetUpdate(model: any) {
    return this.post("/api/Project/UpdateBillingTimesheet", model);
  }

  activityTimeSheetBillingApprove(activityTimeSheetId: any) {
    return this.post("/api/Project/ActivityTimeSheetBillingApprove", activityTimeSheetId);
  }

  activityTimeSheetBillingApproveMulti(activityTimeSheetIds: any) {
    return this.post("/api/Project/ActivityTimeSheetBillingApproveMulti", activityTimeSheetIds);
  }

  activityTimeSheetBillingUnapprove(activityTimeSheetId: any) {
    return this.post("/api/Project/ActivityTimeSheetBillingUnapprove", activityTimeSheetId);
  }

  activityApproveMulti(activityIds: any) {
    return this.post("/api/Activity/ActivityApproveMulti", activityIds);
  }
}

export class TicketModel {
  TicketId: Number;
}
